module.exports = __webpack_public_path__ + "static/assets/b1a70f9547206a96b6b56a05780cfb22.svg";